import { Tag } from 'antd'
import { Company as CompanyModel } from '../../models/Company'

interface Props {
  model: CompanyModel
  type?: 'full' | 'condensed'
}

export const CompanyTag = ({ model }: Props) => {
  const item = model

  if (!item) {
    return <Tag>Société supprimée</Tag>
  }

  return <Tag color="purple">{item.name}</Tag>
}

export type CompanyTagType = { Tag: typeof CompanyTag }
